<div class="data-component-container" [class.tiles-on-mobile]="hasCardView()">
  @if (showTitle() || showSearch()) {
  <div class="header">
    @if (showSearch()) {
    <button class="header__search-icon" (click)="showSearchBar()">
      <img alt="Search" src="assets/icons/common/search.svg">
    </button>
    }
    <div class="header-top">
      <h1 class="header-top__heading">
        @if (showTitle()) {
        <div id="{{tableTitleId()}}">{{tableTitle()}}</div>
        }
      </h1>
      @if (showSearch()) {
      <div class="header-top__search-bar" [class.header-top__search-bar--open]="expandSearch()">
        <app-input-search id="input-search" hint="Search" (modelChange)="search($event)"></app-input-search>
        <button class="header-top__search-bar-close-icon" (click)="hideSearchBar()">
          <img alt="Close Button" src="assets/icons/common/close.svg">
        </button>
      </div>
      }
    </div>
  </div>
  }


  <div class="main">

    @if (showToggle()) {
    <div class="toggle">
      <button type="button" aria-label="Tile view" (click)="viewType.set(VIEW_TYPE_TILE)" [disabled]="viewType() === VIEW_TYPE_TILE">
        <svg-icon svgClass="toggle__tile-img" src="assets/icons/common/tile-view.svg"
          svgAriaLabel="Tile view"></svg-icon>
      </button>
      <button type="button" aria-label="Grid view" (click)="viewType.set(VIEW_TYPE_GRID)" [disabled]="viewType() === VIEW_TYPE_GRID">
        <svg-icon svgClass="toggle__grid-img" src="assets/icons/common/grid-view.svg"
          svgAriaLabel="Grid view"></svg-icon>
      </button>
    </div>
    }

    <div class="container">

      @if (currentPage() && currentPage()!.data.length > 0) {
      <div class="data" [class]="{grid: viewType() === VIEW_TYPE_GRID, tile: viewType() === VIEW_TYPE_TILE}">
        <div class="grid-container" [style.min-width.rem]="tableMinWidthInRem()">
          <table [attr.aria-label]="tableTitle()">
            <colgroup>
              @for (column of columns(); track column) {
              <col [style.width]="column.width">
              }
            </colgroup>
            <thead>
              <tr>
                @for (column of columns(); track column) {
                <th [class]="getColumnClass(column)" [class.sortable]="column.sortable"
                  [class.sorted]="getColumnClassSorted(column)" [class.descending]="getColumnClassDescending(column)"
                  [attr.aria-sort]="getColumnAttributeAriaSort(column)" 
                  [attr.tabindex]="column.headingFocusable ? 0 : null"
                  [attr.aria-label]="column.headingFocusable ? createLabel(column) : null"
                  (click)="sort(column)"
                  (keydown)="onColumnKeyDown($event, column)" scope="col">
                  <span>{{column.title}}</span>
                </th>
                }
              </tr>
            </thead>
            <tbody>
              @for (viewModel of currentPage()!.data; track viewModel) {
              <tr [class.clickable]="clickableRows()" (click)="click(viewModel)"
                (keydown)="onRowKeyDown($event, viewModel)">
                @for (column of columns(); track column) {
                <td [class]="getColumnClass(column)">
                  @if (column.dataFocusable && clickableRows()) {
                  <a tabindex="0" (keyup.enter)="click(viewModel)">
                    <ng-template appTableCellOnload (loadCell)="loadInTableCell($event, column, viewModel)">
                    </ng-template>
                  </a>
                  }
                  @if (column.dataFocusable && !clickableRows()) {
                  <div>
                    <ng-template appTableCellOnload (loadCell)="loadInTableCell($event, column, viewModel)">
                    </ng-template>
                  </div>
                  }
                  @if (!column.dataFocusable) {
                  <div>
                    <ng-template appTableCellOnload (loadCell)="loadInTableCell($event, column, viewModel)">
                    </ng-template>
                  </div>
                  }
                </td>
                }
              </tr>
              }
            </tbody>
          </table>
        </div>
        <div class="tile-container">
          <ng-content></ng-content>
        </div>
      </div>
      }

      @if (!currentPage() || currentPage()!.data.length === 0) {
      <div class="no-data">
        No data available
      </div>
      }

      @if (showPagination()) {
      <div class="pagination">
        <app-pagination [pageData]="paginationPageData()" [currentPage]="paginationCurrentPage()" (goToPage)="page($event)">
        </app-pagination>
      </div>
      }

    </div>
  </div>
</div>